import LeadActions from '../../actions/lead';
import ValidationRunner from './runner';
import {
    notEmpty, lengthAtLeast, lengthAtMost, isValidEmail, isValidPassword,
    isValidWebsite, isValidUnicodeName, isValidLastName, isValidFirstName
} from './rules';
import { fireValidationAction, genericFireAction } from './util';

export default store => next => (action) => {
    let result;
    let resultAction;
    const { app } = store.getState();
    const { features } = app;
    const { isConventionalLodgingFlow } = features;

    switch (action.type) {
    case LeadActions.SET_FIRST_NAME:
        resultAction = LeadActions.setFirstNameValidation;
        result = ValidationRunner(action.firstName, [notEmpty, lengthAtLeast(1),
            lengthAtMost(50), isValidUnicodeName]);
        break;
    case LeadActions.SET_LAST_NAME:
        resultAction = LeadActions.setLastNameValidation;
        result = ValidationRunner(action.lastName, [notEmpty, lengthAtLeast(1),
            lengthAtMost(50), isValidUnicodeName]);
        break;
    case LeadActions.SET_LATIN_FIRST_NAME:
        resultAction = LeadActions.setLatinFirstNameValidation;
        result = ValidationRunner(action.latinFirstName,
            [notEmpty, lengthAtLeast(1), lengthAtMost(50), isValidFirstName]);
        break;
    case LeadActions.SET_LATIN_LAST_NAME:
        resultAction = LeadActions.setLatinLastNameValidation;
        result = ValidationRunner(action.latinLastName,
            [notEmpty, lengthAtLeast(1), lengthAtMost(50), isValidLastName]);
        break;
    case LeadActions.SET_EMAIL:
        resultAction = LeadActions.setEmailValidation;
        result = ValidationRunner(action.email, [notEmpty, isValidEmail]);
        break;
    case LeadActions.SET_PASSWORD:
        resultAction = LeadActions.setPasswordValidation;
        result = ValidationRunner(action.password,
            [notEmpty, isValidPassword, lengthAtLeast(7), lengthAtMost(32)]);
        if (isConventionalLodgingFlow) {
            genericFireAction(store, LeadActions.validatePasswordServerSide, action.password);
        }
        break;
    case LeadActions.SET_WEBSITE:
        resultAction = LeadActions.setWebsiteValidation;
        result = ValidationRunner(action.website, [notEmpty, lengthAtLeast(5),
            lengthAtMost(255), isValidWebsite]);
        break;
    default:
        break;
    }

    if (result && resultAction) {
        fireValidationAction(result, store, resultAction);
    }

    return next(action);
};
